import { Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import { FC } from "react";

type BackgroundTypographyProps = {
  text: string;
  typographyProps?: TypographyProps;
  boxProps?: BoxProps;
};

export const BackgroundTypography: FC<BackgroundTypographyProps> = ({
  text,
  typographyProps,
  boxProps,
}) => {
  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.primary.main,
        p: 1,
        my: 2,
        color: "white",
        borderRadius: 1,
      })}
      {...boxProps}
    >
      <Typography fontWeight={600} variant="h6" {...typographyProps}>
        {text}
      </Typography>
    </Box>
  );
};
